export const addMedicationStyle = {
  buttonContainer: {
    marginTop: 8,
  },
};
